import { Box, Link, Stack, styled, Typography } from '@mui/joy';
import { upperFirst } from 'lodash';

import { ColoredChip } from 'core/elements';
import { parseString } from 'core/utils';
import { IPartBom } from 'partBoms/types';
import { PartNumberHelper } from 'parts/helpers';
import { Color, Direction, Level } from 'theme/enums';

const PartWrapper = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-start',
  gap: '10px',
  padding: '12px 16px',
  backgroundColor: theme.vars.palette.neutral[50],
  border: `1px solid ${theme.vars.palette.neutral[200]}`,
  borderRadius: '6px',
}));

interface IProps {
  partBom: IPartBom;
  onClick?: (partBom: IPartBom) => void;
  getPartCardButtons?: (partBom: IPartBom) => JSX.Element[];
}

export const PartBomCard = ({ partBom, onClick, getPartCardButtons }: IProps) => {
  return (
    <PartWrapper direction={Direction.ROW} key={partBom.id}>
      <Stack flex={1}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {onClick ? (
            <Link
              onClick={() => onClick(partBom)}
              level={Level.TITLE_MD}
              color={Color.PRIMARY}
              sx={{ textWrap: 'wrap' }}
            >
              {PartNumberHelper.toLabel(partBom.number)}
            </Link>
          ) : (
            <Typography color={Color.PRIMARY} level={Level.TITLE_MD}>
              {PartNumberHelper.toLabel(partBom.number)}
            </Typography>
          )}
          <ColoredChip value={upperFirst(partBom.bomType)} />
        </Box>
        <Typography level={Level.TITLE_SM}>{parseString(partBom.descriptionLong)}</Typography>
        <Stack direction={Direction.ROW} justifyContent="flex-end">
          {getPartCardButtons?.(partBom)}
        </Stack>
      </Stack>
    </PartWrapper>
  );
};
